import { render, staticRenderFns } from "./ScrapWCO.vue?vue&type=template&id=47db8474"
import script from "./ScrapWCO.vue?vue&type=script&lang=js"
export * from "./ScrapWCO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports